import { DatePicker as RHFDatePicker } from "$components/rhf-fields";
import type { JSONSchema } from "@elephant-healthcare/yupify";
import React from "react";

type DynamicDateInputProps = {
  fieldDef: JSONSchema;
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
};

export const DynamicDateInput = ({
  fieldDef,
  name,
  label,
  required,
  disabled,
}: DynamicDateInputProps): React.ReactElement => {
  return (
    <RHFDatePicker
      name={name}
      label={label}
      required={required}
      disabled={disabled}
      format="yyyy-MM-dd"
    />
  );
};
